@if (internalValue() && internalValue().length > 0) {
    <mat-chip-listbox
        tabIndex="-1"
        class="st-desk-value-container">
        @for (idx of indexes(); track idx) {
            <mat-chip
                removable
                class="st-desk-value"
                matTooltipPosition="above"
                [matTooltip]="getItemLabel(internalValue()[idx])"
                (removed)="remove(internalValue()[idx])">
                {{ getItemLabel(internalValue()[idx]) }}
            </mat-chip>
        }
    </mat-chip-listbox>
    @if (shouldShowExtraItems()) {
        <div
            #triggerOverlay="cdkOverlayOrigin"
            class="st-desk-value__extra-items"
            cdkOverlayOrigin
            (mouseenter)="showItemTooltip()"
            (mouseleave)="onMouseOut($event)">
            +{{ extraItemsCount() }}
        </div>
        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="triggerOverlay"
            [cdkConnectedOverlayOpen]="isListOpen()"
            (attach)="panelAttached()">
            <mat-list class="st-desk-value__tooltip__content">
                @for (item of tooltipItems(); track item) {
                    <mat-list-item>
                        <div class="st-desk-value__tooltip__info">
                            {{ getItemLabel(item.id) }}
                        </div>
                    </mat-list-item>
                }
            </mat-list>
        </ng-template>
    }
}

@if (hasButtonLabel()) {
    <button
        #trigger
        mat-button
        class="st-desk-button-add"
        [disabled]="disabled()"
        [matMenuTriggerFor]="listDropDownMenu"
        [class.st-desk-button-add-valid]="(required() && internalValue() && internalValue()?.length === 0) || !internalValue()"
        [class.st-desk-button-add-required]="required()"
        (menuClosed)="valueChanged()"
        (menuOpened)="onMenuOpened()">
        <mat-icon> add_business </mat-icon>
        {{ addButtonLabel() }}
    </button>
} @else {
    <button
        #trigger
        mat-icon-button
        class="st-desk-button-add"
        [disabled]="disabled()"
        [matMenuTriggerFor]="listDropDownMenu"
        [class.st-desk-button-add-valid]="(required() && internalValue() && internalValue()?.length === 0) || !internalValue()"
        [class.st-desk-button-add-required]="required()"
        (menuClosed)="valueChanged()"
        (menuOpened)="onMenuOpened()">
        <mat-icon> add_business </mat-icon>
    </button>
}

<mat-menu
    #listDropDownMenu="matMenu"
    class="st-desk-menu">
    <form
        st-click-stop-propagation
        [dir]="dir">
        <mat-form-field
            subscriptSizing="dynamic"
            appearance="fill"
            class="st-desk-form-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
                #searchBox
                type="text"
                matInput
                [placeholder]="searchLabel()"
                [formControl]="deskFilter"
                (keydown.arrowup)="onUpArrowPress()"
                (keydown.arrowdown)="onDownArrowPress()" />
        </mat-form-field>
        <mat-selection-list
            st-click-stop-propagation
            multiple
            [ngModel]="internalValue()"
            (selectionChange)="selected($event)">
            @for (item of filteredOptions | async; track $index) {
                <mat-list-option
                    class="st-desk-list-option"
                    [disabled]="!item.selectable"
                    [value]="item.id">
                    {{ item.title }}
                </mat-list-option>
            }
        </mat-selection-list>
    </form>
</mat-menu>
